export class AssetAncestorModel {
  constructor(
    public assetId: string,
    public assetType: string
  ) {}
}
